import usePrevious from '@nkr/services/use-previous';
import { FormEvent, useEffect, useState } from 'react';
import { Modal, Button } from "react-bootstrap";

// const temporaryOrPermanentMap = {
//     1: "Temporary (Delay Swap)",
//     2: "Permanent (Cancel Swap)"
// }

interface IProps {
    show: boolean,
    swapNumber: string,
    onSend: (message: string, temporaryPermanent: number) => void,
    onCancel: () => void
}

const EmergencyNotification = (props: IProps) => {
    const [message, setMessage] = useState('');
    const [temporaryOrPermanent, setTemporaryOrPermanent] = useState(1);
    const [isValid, setIsValid] = useState(true);

    const previousShow = usePrevious(props.show);

    useEffect(() => {
        if (previousShow == false && props.show) {
            setMessage('');
            setTemporaryOrPermanent(1);
            setIsValid(true);
        }
    }, [props.show]);

    const handleMessageChange = (e: FormEvent<HTMLTextAreaElement>) => {
        setMessage(e.currentTarget.value);
    };

    const handleTemporaryPermanentChnage = (e: FormEvent<HTMLSelectElement>) => {
        setTemporaryOrPermanent(parseInt(e.currentTarget.value));
    };

    const handleSend = () => {
        let isValid = message.length >= 20;

        if (isValid) {
            props.onSend(message, temporaryOrPermanent);
        } else {
            setIsValid(isValid);
        }
    };

    const handleCancel = () => {
        props.onCancel();
    };

    return (
        <Modal backdrop='static' show={props.show} onHide={handleCancel}>
            <Modal.Header closeButton>
                <Modal.Title>Emergency Message Details</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div className={isValid ? "form-group" : "form-group has-error"} style={{ marginBottom: 20 }}>
                    <label className="control-label">{props.swapNumber} Emergency Message</label>
                    <textarea className="form-control" rows={5} cols={80} value={message} onChange={handleMessageChange} />
                    {!isValid ?
                        <div className="help-block">The message must have more than 20 characters...</div>
                        : null}
                </div>

                <div className="form-group">
                    <label className="control-label">Is this a temporary or permanent issue?</label>
                    <select
                        className="form-control"
                        value={temporaryOrPermanent}
                        onChange={handleTemporaryPermanentChnage}
                    >
                        <option value={1}>Temporary (Delay Swap)</option>
                        <option value={2}>Permanent (Cancel Swap)</option>
                    </select>
                </div>
            </Modal.Body>

            <Modal.Footer>
                <Button bsStyle="primary" onClick={handleSend}>Send Emergency Notification</Button>
                <Button onClick={handleCancel}>Cancel</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default EmergencyNotification;